import React, { useState, useEffect } from "react";
import HeroSection from "../components/HomePage/HeroSection";
import UpcomingEvents from "../components/HomePage/UpcomingEvents";
import LatestVideos from "../components/HomePage/LatestVideos";
import PartnerSection from "../components/HomePage/PartnerSection";
import PartnersGrid from "../components/HomePage/PartnersGrid";

// Data imports
import h1 from "../assets/landing_page_cricket.png";
import h2 from "../assets/landing_page_jiu.png";
import h3 from "../assets/landing_page_soccer.png";

import u1 from "../assets/home/u1.png";
import u2 from "../assets/home/u2.png";
import u3 from "../assets/home/u3.jpg";

import v1 from "../assets/home/v1.png";
import v2 from "../assets/home/v2.png";
import v3 from "../assets/home/v3.png";
import v4 from "../assets/home/v4.png";

// Data constants
const slides = [
  {
    img: h1,
    path: "/cricket",
    sport: "Cricket",
  },
  {
    img: h2,
    path: "/jiujitsu",
    sport: "Jiu-Jitsu",
  },
  {
    img: h3,
    path: "/football",
    sport: "Football",
  },
];

const upcomingEvents = [
  {
    img: u1,
    name: "Football",
    text: "We're conducting open tournaments in Football, Cricket and Jiu-Jitsu for all to join and compete.",
    path: "/heroes-day",
  },
  {
    img: u2,
    name: "Cricket",
    text: "We're conducting The Heroes Cup to honor the workforce through sport.",
    path: "/bloom-day",
  },
  {
    img: u3,
    name: "Jiu-Jitsu",
    text: "Bloom Day brings smiles: A day of outdoor fun for special children and their families.",
    path: "/open-events",
  },
];

const latestVideos = [
  {
    img: v2,
    name: "Nellab 1 Amateur Football Highlights",
    youtubeUrl: "https://youtu.be/XgtnslkITmg?si=4UfK-24cki49ZIHp",
  },
  {
    img: v4,
    name: "School Match",
    youtubeUrl: "https://youtu.be/f96Ul93pBYA?si=VM_xZBlCv5NJjP7I",
  },
  {
    img: v1,
    name: "Fastest Jui - jitsu take down",
    youtubeUrl: "https://youtu.be/ZM_8-c1EqOY?si=x-770uwbe-TQJeyn",
  },
  {
    img: v3,
    name: "Why are kids Certainly becoming obese",
    youtubeUrl: "https://youtu.be/hrY4bCKx8Lo?si=2DGATn4lleLKoEzw",
  },
];

const HomePage = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div style={{ width: "100%", maxWidth: "100%", margin: "0 auto" }}>
      {/* Desktop Layout */}
      <div style={{ display: isMobile ? "none" : "block" }}>
        <HeroSection slides={slides} isMobile={isMobile} />
        <UpcomingEvents events={upcomingEvents} isMobile={isMobile} />
        <LatestVideos videos={latestVideos} isMobile={isMobile} />
        <PartnerSection isMobile={isMobile} />
      </div>

      {/* Mobile Layout */}
      <div style={{ display: isMobile ? "block" : "none" }}>
        <HeroSection slides={slides} isMobile={isMobile} />
        <UpcomingEvents events={upcomingEvents} isMobile={isMobile} />
        <LatestVideos videos={latestVideos} isMobile={isMobile} />
        <PartnerSection isMobile={isMobile} />
      </div>

      <GlobalStyles />
    </div>
  );
};

// Extract all CSS to a separate component
const GlobalStyles = () => (
  <style>
    {`
      @keyframes fadeIn {
        0% { opacity: 0; }
        100% { opacity: 1; }
      }

      /* Desktop News Tile Animations */
      .news-tile:hover {
        transform: translateY(-8px);
        box-shadow: 0 12px 24px rgba(0,0,0,0.15);
      }

      .news-image-container {
        position: relative;
        overflow: hidden;
      }

      .news-image {
        transition: all 0.4s ease;
      }

      .news-tile:hover .news-image {
        transform: scale(1.08);
      }

      .news-overlay {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(to bottom, transparent 0%, rgba(0,0,0,0.1) 100%);
        opacity: 0;
        transition: opacity 0.3s ease;
      }

      .news-tile:hover .news-overlay {
        opacity: 1;
      }

      /* Desktop Video Tile Animations */
      .video-tile:hover {
        transform: translateY(-8px);
        box-shadow: 0 12px 24px rgba(0,0,0,0.15);
      }

      .video-image-container {
        position: relative;
        overflow: hidden;
      }

      .video-image {
        transition: all 0.4s ease;
      }

      .video-tile:hover .video-image {
        transform: scale(1.08);
      }

      .video-overlay {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0,0,0,0.3);
        display: flex;
        align-items: center;
        justify-content: center;
        opacity: 0;
        transition: all 0.3s ease;
      }

      .video-tile:hover .video-overlay {
        opacity: 1;
      }

      .play-button {
        transform: scale(0.8);
        transition: transform 0.3s ease;
      }

      .video-tile:hover .play-button {
        transform: scale(1);
      }

      /* Partner Button Animation */
      .partner-button:hover {
        background-color: #fff;
        color: #000;
        transform: translateY(-2px);
        box-shadow: 0 6px 12px rgba(0,0,0,0.2);
      }

      /* Mobile Animations */
      .mobile-news-tile:active {
        transform: scale(0.98);
        box-shadow: 0 2px 8px rgba(0,0,0,0.15);
      }

      .mobile-news-image {
        transition: transform 0.3s ease;
      }

      .mobile-news-tile:active .mobile-news-image {
        transform: scale(1.05);
      }

      .mobile-video-tile:active {
        transform: scale(0.98);
        box-shadow: 0 2px 8px rgba(0,0,0,0.15);
      }

      .mobile-video-image-container {
        position: relative;
      }

      .mobile-video-overlay {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0,0,0,0.3);
        display: flex;
        align-items: center;
        justify-content: center;
        opacity: 0;
        transition: opacity 0.3s ease;
      }

      .mobile-video-tile:active .mobile-video-overlay {
        opacity: 1;
      }

      .mobile-video-tile:active .mobile-video-image {
        transform: scale(1.05);
      }

      .mobile-play-button {
        transform: scale(0.7);
      }

      .mobile-video-tile:active .mobile-play-button {
        transform: scale(0.8);
      }

      .mobile-partner-button:active {
        background-color: #fff;
        color: #000;
        transform: scale(0.95);
      }

      /* Partner Logo Animations */
      .partner-logo:hover {
        transform: translateY(-4px);
        box-shadow: 0 6px 12px rgba(0,0,0,0.15);
      }

      .partner-logo:hover img {
        transform: scale(1.1);
      }
    `}
  </style>
);

export default HomePage;